// extracted by mini-css-extract-plugin
module.exports = {"title":"CreateOrganizationExistingStyle_title__cyrm-","sub_title":"CreateOrganizationExistingStyle_sub_title__1PwNK","container":"CreateOrganizationExistingStyle_container__rpgO6"};